<div>
  <div class="modal-header">
    <button
      id="btnClose"
      type="button"
      class="btn-close close pull-right"
      aria-label="Close"
      (click)="bsModalRef.hide()"
    >
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body api-error-modal" *ngIf="cmsApiErrorCopy.errorMessages">
    <alert type="danger" *ngFor="let error of errors">
      {{
        !!error.code &&
          error.code !== TOKEN_TIMEOUT_ERROR_CODE &&
          error.code !== AGENT_AUTHENTICATION_ERROR_CODE &&
          errorHandlerGenericService.getCopyByErrorKey(error.code, cmsApiErrorCopy.errorMessages)
      }}
    </alert>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-12">
        <button
          id="btnClose"
          class="btn btn-primary"
          (click)="bsModalRef.hide()"
        >
          {{ cmsApiErrorCopy.close }}
        </button>
      </div>
    </div>
  </div>
</div>
